import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bookmarks-modal',
  templateUrl: './bookmarks-modal.html',
  styleUrls: ['./bookmarks-modal.scss']
})
export class BookmarksModal implements OnInit {
  allBookmarks: Array<any> = [];
  isLoading: boolean = false;
  isSavingInProgress: boolean = false;
  topTitle: string = '';
  itemsToSelectLeft: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public popupData: any,
    private dataService: DataService,
    private dialogRef: MatDialogRef<BookmarksModal>
  ) { }

  ngOnInit(): void {
    this.getAllBookmarks();
  }

  getAllBookmarks() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Bookmarks-Api/GetAllBookmarks';

    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData: Array<any>) => {
        responseData.forEach(x => {
          x.selected = this.popupData.selectedbookmarksIds.includes(x.id)
        });

        this.allBookmarks = responseData;
        this.updateTopTitle()
        this.isLoading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.dialogRef.close();
      },
    });
  }

  updateTopTitle() {
    const canBeSelected = 
      this.popupData.maxItemsNumber - this.allBookmarks.filter(x => x.selected).length;
    this.topTitle = this.popupData.popupTitle.replace('{0}', canBeSelected)
    this.itemsToSelectLeft = canBeSelected;
  }

  toggleBookmark(bookmark: any) {
    if(this.isSavingInProgress || (this.itemsToSelectLeft == 0 && !bookmark.selected)) return;
    bookmark.selected = !bookmark.selected;
    this.updateTopTitle()
  }

  saveChanges() {
    if(this.isSavingInProgress) return;

    this.isSavingInProgress = true;
    this.dialogRef.disableClose = true;
    const url = environment.apiUrl + '/Portal/Bookmarks-Api/UpdateUserBookmarks';

    const selectedBookmarks = this.allBookmarks.filter(x => x.selected);
    const request: Array<any> = selectedBookmarks.map(x => x.id);

    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData: Array<any>) => {
        this.isSavingInProgress = false;
        this.dialogRef.close({ updatedBookmarks: selectedBookmarks});
      },
      error: (e: any) => {
        console.error(e);
        this.isSavingInProgress = false;
        this.dialogRef.close();
      },
    });
  }
}
